if (!customElements.get('bulk-orders-controls')) {
  customElements.define('bulk-orders-controls', class BulkOrdersControls extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const slider = this.closest('.bulk-orders-section').querySelector('slider-component');
      if (!slider) return;
      this.controls = Array.from(this.querySelectorAll('button'), (button) => ({
        button,
        target: slider.querySelector(`.slider-buttons button[name="${button.name}"]`),
      })).filter((control) => control.target);
      this.sync = () => this.controls.forEach(({ button, target }) => { button.disabled = target.disabled; });
      this.onClick = (event) => {
        const control = this.controls.find(({ button }) => button === event.target.closest('button'));
        if (control) control.target.click();
      };
      this.addEventListener('click', this.onClick);
      // Keep the visible header arrows in step with Dawn's own boundary/resize state.
      this.observer = new MutationObserver(this.sync);
      this.controls.forEach(({ target }) => this.observer.observe(target, { attributes: true, attributeFilter: ['disabled'] }));
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.removeEventListener('click', this.onClick);
    }
  });
}
